export default {
  STREAM_TIMEOUT: 'STREAM_TIMEOUT',
  ECONNABORTED: 'ECONNABORTED', // axios timeout error code
};
